import authApiCreator from 'data_system/token_auth/api';
import resourceApi from './resourceApi';
import slotsApi from './slotsApi';
import experiencesApi from './experiencesApi';

const baseAuthPath = '/api/resources/auth';
const authApi = authApiCreator(baseAuthPath);

const Api = {
  ...authApi,
  ...resourceApi,
  ...slotsApi,
  ...experiencesApi,
};

export default Api;
